export default __webpack_public_path__ + "973845f7db99da55259c892e6d922662.svg";